/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
export const dataTable = [
    {
        date: "1/5/2018",
        order: 1234504,
        shipTo: "MFG Co., 123 North Fifth, Minneapolis, MN 55406",
        status: "Submitted",
        po: 10000,
        total: 805.92,
    },
    {
        date: "1/4/2018",
        order: 1234503,
        shipTo: "MFG Co., 123 North Fifth, Minneapolis, MN 55406",
        status: "Shipped",
        po: 10000,
        total: 44.01,
    },
    {
        date: "1/3/2018",
        order: 1234502,
        shipTo: "MFG Co., 123 North Fifth, Minneapolis, MN 55406",
        status: "RMA",
        po: 10000,
        total: 123.45,
    },
    {
        date: "1/2/2018",
        order: 1234501,
        shipTo: "MFG Co., 123 North Fifth, Minneapolis, MN 55406",
        status: "Complete",
        po: 10000,
        total: 44.01,
    },
    {
        date: "1/1/2018",
        order: 1234500,
        shipTo: "MFG Co., 123 North Fifth, Minneapolis, MN 55406",
        status: "Complete",
        po: 10000,
        total: 123.45,
    },
];

export const longText =
    "To obtain a price quote, add this item to your cart and select 'Request a Quote' from the cart page. You can request a quote for multiple items.";

export const dynamicDropdownOptions = [
    { optionText: "red", searchString: "rouge reed redd read" },
    { optionText: "orange", searchString: "orag", disabled: true },
    { optionText: "orangered", searchString: "orag" },
    { optionText: "yellow", searchString: "yelloe yeallow", disabled: true },
    { optionText: "green", searchString: "gren grreen grren" },
    { optionText: "blue" },
    { optionText: "indigo", searchString: "jean" },
    { optionText: "violet", searchString: "purple" },
];

export const dummyLinks = [
    {
        children: "Home",
        href: "https://home.insitesoft.com",
    },
    {
        children: "Category",
        href: "https://subcategory.insitesoft.com",
    },
    {
        children: "Subcategory-1",
        href: "https://subcategory.insitesoft.com",
    },
    {
        children: "Subcategory-2",
        href: "https://subcategory.insitesoft.com",
    },
    {
        children: "Subcategory-3",
        href: "https://subcategory.insitesoft.com",
    },
    {
        children: "Subcategory-4",
        href: "https://subcategory.insitesoft.com",
    },
    {
        children: "Subcategory-5",
        href: "https://subcategory.insitesoft.com",
    },
    {
        children: "Current Page",
    },
];

const productData: { product: any; productInfo: any } = {
    product: {
        uri: "http://eis.local.com/api/v2/products/aba66a89-3415-4b19-8c95-9cf600f2e899",
        id: "aba66a89-3415-4b19-8c95-9cf600f2e899",
        productNumber: "GWP232323",
        customerProductNumber: null,
        productTitle: "Anti-Fog Goggle Wipes",
        urlSegment: "GWP232323",
        canonicalUrl: "/Product/GWP232323",
        manufacturerItem: "",
        packDescription: "",
        unitListPrice: 2,
        unitListPriceDisplay: "$2.00",
        priceFacet: 0,
        smallImagePath: "",
        mediumImagePath: "",
        largeImagePath: "",
        imageAltText: "",
        isDiscontinued: false,
        quoteRequired: false,
        minimumOrderQty: 0,
        isSponsored: false,
        trackInventory: false,
        configurationType: "None",
        canConfigure: false,
        canAddToCart: true,
        canAddToWishlist: true,
        canShowPrice: true,
        canShowUnitOfMeasure: true,
        isVariantParent: false,
        variantTypeId: null,
        brand: null,
        productLine: null,
        unitOfMeasures: [
            {
                id: "00000000-0000-0000-0000-000000000000",
                unitOfMeasure: "EA",
                unitOfMeasureDisplay: "EA",
                description: "",
                qtyPerBaseUnitOfMeasure: 1,
                roundingRule: "No Rounding",
                isDefault: true,
            },
        ],
        attributeTypes: [],
        properties: {},
    },
    productInfo: {
        productId: "aba66a89-3415-4b19-8c95-9cf600f2e899",
        qtyOrdered: 1,
        unitOfMeasure: "EA",
        productDetailPath: "/Catalog/Ancillary-Sales/GWP232323",
        inventory: {
            productId: "aba66a89-3415-4b19-8c95-9cf600f2e899",
            qtyOnHand: 0,
            inventoryAvailabilityDtos: [
                {
                    unitOfMeasure: "EA",
                    availability: {
                        messageType: 0,
                        message: null,
                        requiresRealTimeInventory: false,
                    },
                },
            ],
            inventoryWarehousesDtos: [],
            additionalResults: {},
        },
        pricing: {
            productId: "aba66a89-3415-4b19-8c95-9cf600f2e899",
            isOnSale: false,
            requiresRealTimePrice: false,
            additionalResults: {},
            unitCost: 0,
            unitCostDisplay: null,
            unitListPrice: 2,
            unitListPriceDisplay: "$2.00",
            extendedUnitListPrice: 2,
            extendedUnitListPriceDisplay: "$2.00",
            unitRegularPrice: 2,
            unitRegularPriceDisplay: "$2.00",
            extendedUnitRegularPrice: 2,
            extendedUnitRegularPriceDisplay: "$2.00",
            unitNetPrice: 2,
            unitNetPriceDisplay: "$2.00",
            extendedUnitNetPrice: 2,
            extendedUnitNetPriceDisplay: "$2.00",
            unitOfMeasure: "EA",
            unitListBreakPrices: [],
            unitRegularBreakPrices: [],
            regularPrice: 2,
            regularPriceDisplay: "$2.00",
            extendedRegularPrice: 2,
            extendedRegularPriceDisplay: "$2.00",
            actualPrice: 2,
            actualPriceDisplay: "$2.00",
            extendedActualPrice: 2,
            extendedActualPriceDisplay: "$2.00",
            regularBreakPrices: [],
            actualBreakPrices: [],
        },
    },
};

export const dummyProductContext = {
    product: productData.product,
    productInfo: productData.productInfo,
    onUnitOfMeasureChanged: () => {},
    onQtyOrderedChanged: () => {},
};
